export class UtmParameters {
    utmSource: string;
    utmMedium: string;
    utmCampaign: string;
    utmTerm: string;
    utmContent: string;
}

// https://gateflix.in/gate-video-lectures/?utm_source=Facebook&utm_medium=PaidPost&utm_campaign=sale_24&utm_term=&utm_content=